import TokenService from "@/common/token.service.js";
import ApiService from '@/common/api.service.js'

const state = {
	info: {
		id: null,
		first_name: null,
		last_name: null,
		email: null,
		nfc: null,
		phone: null,
		budget: null,
		role: null,
		role_text: null,
		company_id: null,
		location_id: null,
		shift_id: null,
		change_pass: null,
		status: null
	},
	company: {
		id: null,
		name: null,
		cui: null,
		phone: null,
		city: null,
		address: null,
		email: null,
		contact: null,
		status: null
	}
}

const actions = {
	login: (context, payload) => {
		return new Promise((resolve, reject) => {
			ApiService.post('auth/login', {
				email: payload.email,
				password: payload.password,
				nfc: payload.nfc
			}).then(data => {
				TokenService.save(data.data.access_token)
				TokenService.saveRole(data.data.role)
				TokenService.saveExpire(data.data.expires_in)
				ApiService.setAuthHeader(data.data.access_token)
				//vm.$db.addUser(data.data)
				resolve()
			}).catch(err => {
				reject(err)
			})
		})
	},
	logout: (context, payload) => {
		TokenService.removeAll();
		ApiService.resetHeaders();
		window.location.href = process.env.VUE_APP_URL_AUTH;
	},
	get: (context) => {
		return new Promise((resolve, reject) => {
			ApiService.get(`${process.env.VUE_APP_API_URL}auth/user/?include=company`).then(result => {
				context.commit('user/info', _.omit(result.data.data, 'company'), {root: true})
				context.commit('user/company', result.data.data.company.data, {root: true})
				context.commit('preorder/customer', result.data.data.id, {root: true})
				resolve()
			}).catch(err => {
				console.log(err)
				reject(err)
			});
		})
	},
	details: (context, payload) => {
        return new Promise((resolve, reject) => {
            ApiService.get('auth/user?include=company,settings').then(response => {
				if (response) {
					context.commit('info', response.data.data);
					vm.$db.setUser(response.data.data);
				}
				// else {
				// 	vm.$db.getUser().then( user => {
				// 		context.commit('info', user);
				// 	})
				// }
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
	},
}

const mutations = {
	info (state, info) {
		state.info = info;
	},
	company (state, companyInfo) {
		state.company = companyInfo
	}
}

const getters = {
	info: state => state.info,
	company: state => state.company
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
